module.exports = __webpack_public_path__ + "static/media/senseview-3.c3a89cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/section-images/senseview-3.png
// module id = 93
// module chunks = 0